
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gangwon-veterans",
      function () {
        return require("private-next-pages/gangwon-veterans/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gangwon-veterans"])
      });
    }
  